import { CAT_EVENT_THEMES } from 'App/utils/Collections';

export default {
  category: CAT_EVENT_THEMES,
  filters: [],
  useStrictSearch: false,
  searchBarProp: 'translations.name',
};
